































































































































































































































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {User} from '@/models';

const Auth = namespace('Auth');
import {
  BizSirenEncodeResponse,
  BizSirenResultDto,
  checkDuplicateUserIdDto,
  LoginDto,
  SignUpDto,
} from '@/services/LoginModels';
import {loginService} from '@/services/login.service';
import {mixins} from 'vue-class-component';
import GeneralUtil from '@/util/GeneralUtil';
import FormRequiredInput from '@/components/forms/FormRequiredInput.vue';

interface YourComponentType extends Vue {
  validate(): any;
}
@Component({
  components: {
    FormRequiredInput,
  },
})
export default class MyInfoManage extends mixins(GeneralUtil) {
  @Auth.Getter
  public loginUser!: User;
  @Auth.Action
  public signOut!: () => void;
  private isPWChecked = false;
  private isPWReset = false;
  private userPasswd = '';
  signUpDto: SignUpDto = {
    guestName: '',
    birthday: '',
    lunarCode: '1',
    sex: 'M',
    userId: '',
    userPasswd: '',
    hpNo: '',
    smsSendYn: 'N',
    email: '',
    emailYn: 'N',
    marketingYn: 'N',
    guestNo: '',
    opinionYn: 'Y',
    prsinClctn01: 'Y',
    prsinClctn02: 'Y',
    prsinClctn03: 'Y',
  };
  private smsSendYn = 'N';
  private emailYn = 'N';
  private checkUserLeave = false;
  private newPassword = '';
  private passwordRepeat = '';
  private text = '○ 핀크스 회원탈퇴 유의사항1 \n○ 핀크스 회원탈퇴 유의사항2';
  private userId = '';
  SNSNOTCONNECTED = '계정연동없음';
  private snsConnected = this.SNSNOTCONNECTED;
  private identityAuth = false;
  private host = window.location.protocol + '//' + window.location.host;
  private reqInfo = '';
  private windowRef: any = null;
  private tabIndex = 0;

  readonly MEMTYPE_BUBIN_PKG = '006'; //법인Pkg 고객 타입 (추천인 예약 가능)
  readonly MEMTYPE_GENERAL = '001'; //일반회원
  readonly MEMTYPE_GOLD = '004'; //골드회원

  $refs!: {
    observer2: YourComponentType;
  };

  @Watch('signUpDto.marketingYn', {immediate: true, deep: true})
  public marketingYnChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      if (newValue === 'N') {
        this.signUpDto.emailYn = newValue;
        this.signUpDto.smsSendYn = newValue;
      }
    }
  }

  get isMyMemTypeNotChangeContact(): boolean {
    if (!this.selectedMember) return false;
    return (
      this.selectedMember.memType === this.MEMTYPE_BUBIN_PKG ||
      this.selectedMember.memType === this.MEMTYPE_GENERAL ||
      this.selectedMember.memType === this.MEMTYPE_GOLD
    );
  }

  mounted(): void {
    // eslint-disable-next-line
    window.recvSirenPhoneResult = this.recvSirenPhoneResult;
    if (this.$route.query.ResetPW) {
      this.isPWChecked = true;
      this.isPWReset = true;
      this.tabIndex = 1;
      this.userPasswd = this.$route.query.userPasswd as string;
    }

    // if (this.isMyMemTypeCorpMember) this.tabIndex = 1;
  }

  openPhoneAuthPopup(): void {
    //console.log(this.authPhoneDto);

    //핸드폰 본인인증 창열
    const retUrl = this.host + '/noHeader/p/bizSirenCallBackPhone';
    loginService.getBizSirenEncode(retUrl).then(response => {
      if (response.status == 200) {
        const responseData = response.data as BizSirenEncodeResponse;
        this.reqInfo = responseData.reqInfo;
        this.windowRef = window.open(
          '',
          '',
          'width=430, height=560, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200',
        );
        const popupDocument = this.windowRef.document;
        const frm = popupDocument.createElement('form');
        frm.setAttribute('id', 'auth-form');
        frm.setAttribute('action', 'https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v4.jsp');
        frm.setAttribute('method', 'post');
        frm.setAttribute('target', '_self');

        const element1 = popupDocument.createElement('input');
        element1.type = 'hidden';
        element1.value = responseData.cryptoTokenId;
        element1.name = 'crypto_token_id';
        frm.appendChild(element1);

        const element2 = popupDocument.createElement('input');
        element2.type = 'hidden';
        element2.value = responseData.integrityValue;
        element2.name = 'integrity_value';
        frm.appendChild(element2);

        const element3 = popupDocument.createElement('input');
        element3.type = 'hidden';
        element3.value = responseData.reqInfo;
        element3.name = 'reqInfo';
        frm.appendChild(element3);

        const element4 = popupDocument.createElement('input');
        element4.type = 'hidden';
        element4.value = responseData.verSion;
        element4.name = 'verSion';
        frm.appendChild(element4);

        popupDocument.body.appendChild(frm);
        //this.windowRef.document.body.appendChild(this.$el);
        //copyStyles(window.document, this.windowRef.document);
        //this.windowRef.addEventListener('beforeunload', this.closePopup);
        frm.submit();
      } else {
        //http response 오류 처리
      }
    });
  }

  recvSirenPhoneResult(type: string, result: BizSirenResultDto): void {
    console.log(result);
    // this.signUpDto.guestName = result.name;
    // this.signUpDto.birthday = result.birYMD;
    // this.signUpDto.sex = result.sex;
    if (this.signUpDto.guestName !== result.name || this.signUpDto.birthday !== result.birYMD) {
      this.$bvModal.msgBoxOk('이름과 생년월일이 일치하지 않습니다.', {
        title: '인증 실패',
        okVariant: 'danger',
        centered: true,
      });
      return;
    }
    if (type === 'phone') {
      this.signUpDto.hpNo = result.cellNo;
    }
    this.identityAuth = true;
  }

  async cancelMypage() {
    const confirm = await this.$bvModal.msgBoxConfirm('정말 취소하시겠습니까?', {
      title: '고객정보수정 취소',
      okVariant: 'success',
      centered: true,
    });
    if (!confirm) {
      return;
    }
    this.$router.go(-1);
  }

  chkEmailAuth = false;
  emailAuthCode = '';

  sendEmailAuthCode(): void {
    const changeEmail = this.signUpDto.email.trim();
    if (changeEmail === '') {
      this.$bvModal.msgBoxOk('이메일 입력하세요.', {
        title: '이메일주소 입력필요',
        okVariant: 'danger',
        centered: true,
      });
      return;
    } else {
      loginService.sendEmailAuthCode(this.signUpDto.email).then(response => {
        if (response.status == 200) {
          this.$bvModal.msgBoxOk('이메일 발송성공 이메일에서 인증코드를 확인 후 입력해주세요.', {
            title: '성공',
            okVariant: 'success',
            centered: true,
          });
          this.chkEmailAuth = false;
        } else {
          this.$bvModal
            .msgBoxOk('이메일 발송실패', {
              title: '오류발생',
              okVariant: 'danger',
              centered: true,
            })
            .then(value => {
              this.chkEmailAuth = false;
            });
        }
      });
    }
  }

  async checkEmailAuthCode(): Promise<void> {
    if (this.signUpDto.email === '') {
      this.$bvModal.msgBoxOk('이메일주소를 입력하세요.', {
        title: '이메일주소 입력필요',
        okVariant: 'danger',
        centered: true,
      });
      return;
    }
    if (this.emailAuthCode === '') {
      this.$bvModal.msgBoxOk('인증코드를 입력하세요.', {
        title: '인증코드입력필요',
        okVariant: 'danger',
        centered: true,
      });
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const popupTitle = '이메일 인증';
    let errorMessage = '';
    await loginService
      .checkEmailAuthCode(this.emailAuthCode)
      .then(response => {
        this.$bvModal
          .msgBoxOk(`${popupTitle} 성공`, {
            title: '성공',
            okVariant: 'success',
            centered: true,
          })
          .then(value => {
            this.chkEmailAuth = true;
          });
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            errorMessage = '인증번호가 일치하지 않습니다.';
          } else if (error.response.status === 409) {
            errorMessage = "만료된 인증번호입니다. <br>재시도 하시려면 '인증번호 받기'를 눌러주세요.";
          } else {
            errorMessage = `${popupTitle} 서버 오류발생`;
          }
        } else if (error.request) {
          errorMessage = `${popupTitle} 요청 오류발생`;
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          errorMessage = `${popupTitle} 요청 오류발생`;
          console.log('Error', error.message);
        }
        //console.log(error.config);
        self.$bvModal.msgBoxOk(self.htmlToVNode(errorMessage), {
          title: `${popupTitle} 오류발생`,
          okVariant: 'danger',
          centered: true,
        });
        self.chkEmailAuth = false;
      })
      .finally(() => {
        self.hideLoadingModal();
      });
  }

  changeMyinfo(): void {
    if (
      !this.isMyMemTypeNotChangeContact &&
      !this.chkEmailAuth &&
      this.loginUser.email.trim() !== this.signUpDto.email.trim() &&
      this.signUpDto.email.trim() !== ''
    ) {
      this.$bvModal.msgBoxOk('이메일을 인증해주세요.', {
        title: '인증코드 입력필요',
        okVariant: 'danger',
        centered: true,
      });
      return;
    }

    this.$bvModal
      .msgBoxConfirm('고객 정보를 수정하시겠습니까?', {
        title: '고객정보 수정',
        okVariant: 'success',
        centered: true,
      })
      .then(value => {
        if (value === true) {
          loginService
            .userMyInfoChange(this.loginUser, this.signUpDto)
            .then(response => {
              if (response.status == 200) {
                const responseData = response.data;
                if (responseData.resultCode == '0000') {
                  //로그인 성공 mypage로 이동
                  this.$bvModal.msgBoxOk('고객정보가 변경되었습니다.', {
                    title: '고객정보 변경 성공',
                    okVariant: 'success',
                    centered: true,
                  });
                } else {
                  //PMS 로그인 에러처리 필요
                  this.$bvModal.msgBoxOk(responseData.msg, {
                    title: '고객정보 변경 실패',
                    okVariant: 'danger',
                    centered: true,
                  });
                }
              }
            })
            .catch(error => {
              console.log(error.response);
              //window.opener.recvKakaoResult(error.response);
              this.$bvModal.msgBoxOk(error.response.data, {
                title: '고객정보 변경 실패',
                centered: true,
              });
            });
        }
      });
  }

  checkUserPasswd(): void {
    console.log(this.userPasswd);
    if (this.userPasswd === '') {
      this.$bvModal.msgBoxOk('비밀번호를 입력해주세요.', {
        title: '비밀번호 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }
    loginService
      .userPWCheck(this.loginUser, this.userPasswd)
      .then(response => {
        if (response.status == 200) {
          const responseData = response.data;
          if (responseData.resultCode == '0000') {
            this.isPWChecked = true;
            this.chkEmailAuth = false;
            this.getMyInfo();
          } else {
            this.$bvModal.msgBoxOk('패스워드가 일치하지 않습니다.', {
              title: '오류발생',
              okVariant: 'danger',
              centered: true,
            });
          }
        } else {
          //http response 오류 처리
        }
      })
      .catch(error => {
        console.log(error.response);
        //window.opener.recvKakaoResult(error.response);
        this.$bvModal.msgBoxOk(
          this.htmlToVNode('비밀번호가 일치하지 않습니다.<br> 입력한 내용을 다시 확인해 주세요.'),
          {
            title: '비밀번호 확인 실패',
            centered: true,
          },
        );
      });
  }

  async userPwChange(): Promise<void> {
    const isValid = await this.$refs.observer2.validate();
    if (!isValid) {
      await this.$bvModal.msgBoxOk('비밀번호를 규칙에 맞게 입력해주세요.', {
        title: '비밀번호 규칙 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }

    if (this.newPassword !== '' && this.newPassword === this.userPasswd) {
      this.$bvModal.msgBoxOk('기존 비밀번호와 다른 비밀번호로 입력해주세요.', {
        title: '비밀번호 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }
    if (this.newPassword.trim() === '') {
      this.$bvModal.msgBoxOk('비밀번호를 입력해주세요.', {
        title: '비밀번호 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }
    if (this.newPassword !== this.passwordRepeat) {
      this.$bvModal.msgBoxOk('비밀번호가 맞지 않습니다.', {
        title: '비밀번호 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }
    this.$bvModal
      .msgBoxConfirm('비밀번호를 변경하시겠습니까?', {
        title: '비밀번호 변경',
        okVariant: 'success',
        centered: true,
      })
      .then(value => {
        loginService
          .userPwChange(this.loginUser, this.userPasswd, this.newPassword)
          .then(async response => {
            if (response.status == 200) {
              const responseData = response.data;
              if (responseData.resultCode == '0000') {
                await this.$bvModal.msgBoxOk('패스워드 변경을 완료하였습니다.', {
                  title: '패스워드 변경 성공',
                  okVariant: 'success',
                  centered: true,
                });
                // if(this.isPWReset){
                //   this.signOut();
                //   this.$router.push('/');
                // }
                this.$router.push('/');
              } else {
                this.$bvModal.msgBoxOk('패스워드가 일치하지 않습니다.', {
                  title: '오류발생',
                  okVariant: 'danger',
                  centered: true,
                });
              }
            } else {
              //http response 오류 처리
            }
          })
          .catch(error => {
            console.log(error.response);
            //window.opener.recvKakaoResult(error.response);
            this.$bvModal.msgBoxOk(
              this.htmlToVNode('비밀번호가 일치하지 않습니다.<br> 입력한 내용을 다시 확인해 주세요.'),
              {
                title: '비밀번호 확인 실패',
                centered: true,
              },
            );
          });
      });
  }

  getMyInfo(): void {
    loginService
      .userMyInfo()
      .then(response => {
        if (response.status == 200) {
          const userInfo = response.data.obj as User;
          console.log(userInfo);
          if (response.data.resultCode == '0000') {
            this.signUpDto.guestName = userInfo.guestName;
            this.signUpDto.hpNo = userInfo.hpNo;
            this.signUpDto.birthday = userInfo.birthday;
            this.signUpDto.email = userInfo.email.trim();
            this.signUpDto.userPasswd = this.userPasswd;
            this.signUpDto.userId = 'modifyUserInfo';
            this.signUpDto.smsSendYn = userInfo.smsSendYn;
            this.signUpDto.emailYn = userInfo.emailYn;
            this.signUpDto.marketingYn = userInfo.marketingYn;
            console.log('signUpDto', this.signUpDto);
            if (userInfo.snsToken) {
              this.snsConnected = '계정 연동 중';
            }
          } else {
            this.$bvModal.msgBoxOk('회원조회 실패', {
              title: '오류발생',
              okVariant: 'danger',
              centered: true,
            });
          }
        } else {
          //http response 오류 처리
        }
      })
      .catch(error => {
        console.log(error.response);
        //window.opener.recvKakaoResult(error.response);
        this.$bvModal.msgBoxOk(error.response.data, {
          title: '회원 조회 실패',
          centered: true,
        });
      });
  }

  snsUserLeave(): void {
    if (!this.checkUserLeave) {
      this.$bvModal
        .msgBoxConfirm('SNS 계정연동을 초기화하시겠습니까?', {
          title: 'SNS 계정연동 초기화',
          okVariant: 'success',
          centered: true,
        })
        .then(value => {
          if (value === true) {
            loginService
              .userIdFind(this.loginUser)
              .then(response => {
                if (response.status == 200) {
                  const responseData = response.data;
                  if (responseData.resultCode == '0000') {
                    this.userId = responseData.obj.userId;
                    this.snsUserLeaveConfirm();
                  } else {
                    this.$bvModal
                      .msgBoxOk('아이디 검색안됨', {
                        title: '오류발생',
                        okVariant: 'danger',
                        centered: true,
                      })
                      .then(value => {
                        this.userId = '';
                      });
                  }
                } else {
                  //http response 오류 처리
                }
              })
              .catch(error => {
                console.log(error.response);
                //window.opener.recvKakaoResult(error.response);
                this.$bvModal.msgBoxOk(error.response.data, {
                  title: '아이디 검색실패',
                  centered: true,
                });
              });
          }
        });
      return;
    }
  }

  snsUserLeaveConfirm(): void {
    loginService
      .snsUserLeave(this.userId, this.loginUser.snsToken)
      .then(response => {
        if (response.status == 200) {
          const responseData = response.data;
          if (responseData.resultCode == '0000') {
            this.$bvModal.msgBoxOk('SNS 계정이 초기화되었습니다.', {
              title: '성공',
              okVariant: 'success',
              centered: true,
            });
            this.snsConnected = this.SNSNOTCONNECTED;
          } else {
            this.$bvModal.msgBoxOk('SNS 계정초기화 실패', {
              title: '오류발생',
              okVariant: 'danger',
              centered: true,
            });
          }
        } else {
          //http response 오류 처리
        }
      })
      .catch(error => {
        console.log(error.response);
        //window.opener.recvKakaoResult(error.response);
        this.$bvModal.msgBoxOk(error.response.data, {
          title: 'SNS 계정초기화 실패',
          centered: true,
        });
      });
  }

  userLeave(): void {
    if (!this.checkUserLeave) {
      this.$bvModal.msgBoxOk('회원탈퇴 동의를 해주세요.', {
        title: '회원탈퇴 동의 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }

    loginService
      .userIdFind(this.loginUser)
      .then(response => {
        if (response.status == 200) {
          const responseData = response.data;
          if (responseData.resultCode == '0000') {
            this.userId = responseData.obj.userId;
            this.userLeaveConfirm();
          } else {
            this.$bvModal
              .msgBoxOk('아이디 검색안됨', {
                title: '오류발생',
                okVariant: 'danger',
                centered: true,
              })
              .then(value => {
                this.userId = '';
              });
          }
        } else {
          //http response 오류 처리
        }
      })
      .catch(error => {
        console.log(error.response);
        //window.opener.recvKakaoResult(error.response);
        this.$bvModal.msgBoxOk(error.response.data, {
          title: '아이디 검색실패',
          centered: true,
        });
      });
  }

  userLeaveConfirm(): void {
    this.$bvModal
      .msgBoxConfirm('정말로 회원을 탈퇴하시겠습니까?', {
        title: '회원탈퇴',
        okVariant: 'danger',
        centered: true,
      })
      .then(value => {
        if (value === true) {
          loginService
            .userLeave(this.loginUser, this.userId)
            .then(response => {
              if (response.status == 200) {
                const responseData = response.data;
                if (responseData.resultCode == '0000') {
                  this.$bvModal
                    .msgBoxOk('정상적으로 회원탈퇴를 완료하였습니다.', {
                      title: '성공',
                      okVariant: 'success',
                      centered: true,
                    })
                    .then(value => {
                      this.signOut();
                      this.$router.push('/');
                    });
                } else {
                  this.$bvModal.msgBoxOk('회원탈퇴 실패', {
                    title: '오류발생',
                    okVariant: 'danger',
                    centered: true,
                  });
                }
              } else {
                //http response 오류 처리
              }
            })
            .catch(error => {
              console.log(error.response);
              //window.opener.recvKakaoResult(error.response);
              this.$bvModal.msgBoxOk(error.response.data, {
                title: '회원 탈퇴 실패',
                centered: true,
              });
            });
        }
      });
  }

  removeEventSpaces(e: any): void {
    e.preventDefault();
    const left = e.target.value.substring(0, e.target.selectionStart);
    const right = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
    const pasted = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
    e.target.value = left + pasted + right;
  }
}
